import { useMemo } from "react";
import { useTranslation } from "next-i18next";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import content from "../content";

export const useGetContent = () => {
    const { t } = useTranslation();
    const { locale } = useUTSLocaleContext();

    return useMemo(() => content(t, locale), [t, locale]);
};
